import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Subject } from 'rxjs';
import { HttpClientModule } from '@angular/common/http';


import { logbaseService } from "../../services/logbase.service";
import { NewPackageService } from '../../services/NewPackage.service';


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  lineDataList: any;
  lineData: any;
  groupNumbers: any;
  lineNumbers: any;
  lineNumList: any;
  lineNumber: any;
  inProgressList: any;
  userList: any;
  userRoleID: any;
  approvedList: any;
  rejectedList: any;
  newList: any;
  todoList: any;
  todos: any;
  adminAccess: any;
  loggedInUser: any;
  packages: any;
  parts: any;

  data: any = null;
  newPartsCount: number = null;
  partStatusCount: number = null;
  packageRevisionCount: number = null;
  newPackageCount: number = null;
  todoCount: number = null;
  notificationCount: number = null;
  dropdownValues = [];

  private jsonFileURL: string = "assets/api/json/notification_count.json";

  constructor(private http: HttpClient, private logbaseService: logbaseService, private newPackageService: NewPackageService) {

    let userDetails = localStorage.getItem('userDetails');
    let userDetJson = JSON.parse(userDetails);
    this.loggedInUser = userDetJson.loginId;
    this.adminAccess = userDetJson.userRoleMappings[0].roleId;
  }

  ngOnInit() {
    localStorage.removeItem('cacheUser');
    let userDetails = localStorage.getItem('userDetails');
    let userDetJson = JSON.parse(userDetails);
    this.userRoleID = userDetJson.userRoleMappings[0].roleId;
    this.lineNumbers = userDetJson.lineNumbers;
    this.groupNumbers = userDetJson.groupNumbers;
   // let rowArrayRaw=localStorage.getItem('userRoleArray');
     // this.dropdownValues=JSON.parse(rowArrayRaw);
    // if (this.lineNumbers != null) {
    //   this.lineNumber = userDetJson.lineNumbers.toString();
    // }
    // if (this.userRoleID != 4 && this.userRoleID != 10 && this.userRoleID != 11 && this.userRoleID != 13 && this.userRoleID != 5) {
    //   this.logbaseService.getNewStatusParts()
    //     .subscribe(result => {
    //       this.parts = result.response;
    //       this.newPartsCount = this.parts.length;
    //     });
    // }

    // if (this.userRoleID != 4 && this.userRoleID != 10 && this.userRoleID != 11 && this.userRoleID != 5) {
    //   this.logbaseService.getNewPartTodoList()
    //     .subscribe(result => {
    //       this.todos = result;
    //       this.todoList = this.todos.response;
    //       if (this.userRoleID == 1) {
    //         this.newList = this.todoList.new.length;
    //         this.rejectedList = this.todoList.rejected.length;
    //         this.inProgressList = this.todoList.inProgress.length;
    //         this.todoCount = this.newList + this.rejectedList + this.inProgressList;
    //       }
    //       else if (this.userRoleID == 2 || this.userRoleID == 3 || this.userRoleID == 7) {
    //         this.todoCount = this.todoList.underReview.length;
    //       }
    //     });
    // }

    // else if (this.userRoleID == 4) {
    //   this.logbaseService.getTodoByLineNumbers(this.lineNumber).subscribe(
    //     result => {
    //       this.todoCount = result.response.underReview.length;
    //     })
    // }
    // else if ( this.userRoleID == 11){
    //   var DatatoSend = {
    //     groupNumbers: this.groupNumbers,
    //     lineNumbers: this.lineNumbers
    //   }
    //   this.logbaseService.lineWorkerTodo(DatatoSend).subscribe(
    //     result => {
    //       this.lineData = result;
    //       this.todoCount = this.lineData.response.length;
    //     }
    //   )}
  }

}
